import { escapeHtml } from '../utils.js';

const PARENT_LABELS = {
  epic: 'Epic',
  story: 'Story',
  bug: 'Bug',
  task: 'Task',
};

export function renderParentContext(parent) {
  if (!parent) return '';
  const label = PARENT_LABELS[parent.type] || 'Parent';
  return `<div class="task-parent-context form-group" role="note" style="border-left:3px solid var(--c-mauve);padding:0.65rem 0.85rem;background:var(--c-surface0);border-radius:6px;overflow-wrap:anywhere">
    <span class="form-label">${label}</span>
    <strong><span class="badge">${escapeHtml(parent.task_key)}</span> ${escapeHtml(parent.title)}</strong>
  </div>`;
}

// Kept for existing callers and docs; epic context is the specialized form of parent context.
export function renderEpicContext(epic) {
  return epic?.type === 'epic' ? renderParentContext(epic) : '';
}
